import { render, staticRenderFns } from "./KanbanEditModal.vue?vue&type=template&id=0961c673"
import script from "./KanbanEditModal.vue?vue&type=script&lang=js"
export * from "./KanbanEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports